import { css } from "@emotion/react";
import type React from "react";
import { useCatalogState } from "../../../hooks/useCatalogState";
import {
	type ShoppingCartItemModel,
	useShoppingCartItemsState,
} from "../../../hooks/useShoppingCartItemsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { ShoppingCartItemAvailability } from "../ItemFields/ShoppingCartItemAvailability";
import { ShoppingCartItemImage } from "../ItemFields/ShoppingCartItemImage";
import { ShoppingCartItemQty } from "../ItemFields/ShoppingCartItemQty";
import { ShoppingCartItemRates } from "../ItemFields/ShoppingCartItemRates";
import { getShoppingCartProductViewSettings } from "../ShoppingCartControl";
import { ShoppingCartPackageItemsDesktop } from "./ShoppingCartPackageItemsDesktop";

export type ShoppingCartItemProps = {
	shoppingCartItem: ShoppingCartItemModel;
	index: number;
	isRowNumberColumnVisible: boolean;
	isImageColumnVisible: boolean;
	isDescriptionColumnVisible: boolean;
	isPriceColumnVisible: boolean;
	isQuantityColumnVisible: boolean;
	isDesktop: boolean;
};
export const ShoppingCartItemRow: React.FC<ShoppingCartItemProps> = (props) => {
	const translate = useTranslate();
	const shoppingCartItemsState = useShoppingCartItemsState();
	const shoppingCartItem = props.shoppingCartItem;
	const isDesktop = props.isDesktop;
	const catalogState = useCatalogState();
	const catalogs = catalogState.get().catalogs;

	if (catalogs && props.shoppingCartItem.product) {
		const product = props.shoppingCartItem.product;
		const viewSettings = getShoppingCartProductViewSettings(catalogs, product);
		return (
			<>
				<tr className="item">
					<td css={css`width:32px;text-align:center;font-size:.8rem;`}>
						{props.isRowNumberColumnVisible && <>{props.index + 1}.</>}
					</td>
					<td css={css`width: 64px;`}>
						{props.isImageColumnVisible && (
							<ShoppingCartItemImage item={shoppingCartItem} />
						)}
					</td>
					<td className="description">
						{props.isDescriptionColumnVisible && (
							<>
								<div className="px-2 text-sm font-bold">
									{props.shoppingCartItem.product.ItemName}
								</div>
								{viewSettings.hasICode && (
									<div className="px-2 text-xs">
										#{props.shoppingCartItem.product.InventoryNo}
									</div>
								)}
								{!isDesktop && viewSettings.hasRates && (
									<div className="px-2">
										<ShoppingCartItemRates
											item={shoppingCartItem}
											hasDailyRate={viewSettings.hasDailyRate}
											hasWeeklyRate={viewSettings.hasWeeklyRate}
											hasMonthlyRate={viewSettings.hasMonthlyRate}
											hasSalesPrice={viewSettings.hasSalesPrice}
											justifyContent="flex-start"
										/>
									</div>
								)}
								<div css={css`display:flex;flex-wrap:wrap;`}>
									{shoppingCartItem.product.PackageItems && (
										<button
											type="button"
											css={css`
												white-space: nowrap;
												cursor: pointer;
												font-weight: 600;
												border: 0;
												padding: 0 0.5rem;
												background-color: transparent;
												color: oklch(0.64 0.21 250.64);
												&:hover {
													text-decoration: underline;
												}
											`}
											onClick={() => {
												shoppingCartItemsState.setShowPackageItems(
													shoppingCartItem,
													!shoppingCartItem.showPackageItems,
												);
											}}
										>
											{shoppingCartItem.showPackageItems
												? translate("Hide accessories")
												: translate("View accessories")}
										</button>
									)}
								</div>
							</>
						)}
					</td>
					{isDesktop && (
						<td css={css`width: 200px;padding: 0 8px;`}>
							{props.isPriceColumnVisible &&
								isDesktop &&
								viewSettings.hasRates && (
									<ShoppingCartItemRates
										item={shoppingCartItem}
										hasDailyRate={viewSettings.hasDailyRate}
										hasWeeklyRate={viewSettings.hasWeeklyRate}
										hasMonthlyRate={viewSettings.hasMonthlyRate}
										hasSalesPrice={viewSettings.hasSalesPrice}
									/>
								)}
						</td>
					)}
					<td css={css`width: 120px;padding: 0 8px;`}>
						{props.isQuantityColumnVisible && (
							<>
								<ShoppingCartItemQty
									item={shoppingCartItem}
									index={props.index}
								/>
								<div css={css`padding:0 .25rem;`}>
									{viewSettings.hasAvailability && (
										<ShoppingCartItemAvailability item={shoppingCartItem} />
									)}
								</div>
							</>
						)}
					</td>

					{/*<td>*/}
					{/*    <ShoppingCartItemDeleteButton item={shoppingCartItem} />*/}
					{/*</td>*/}
				</tr>
				{shoppingCartItem.showPackageItems &&
					shoppingCartItem.product.PackageItems && (
						<tr className="packageitem">
							<td></td>
							<td colSpan={4}>
								<ShoppingCartPackageItemsDesktop
									shoppingCartItem={shoppingCartItem}
									index={props.index}
									viewSettings={viewSettings}
								/>
							</td>
						</tr>
					)}
			</>
		);
	}
	return null;
};
